export default function LieuxConfiguration($translatePartialLoaderProvider) {
    // On configure la gestion de la traduction en lui indiquant quel fichier json il doit charger pour ce module
    $translatePartialLoaderProvider.addPart('lieux');
}

LieuxConfiguration.$inject = ['$translatePartialLoaderProvider'];
